import { useOutletContext, useNavigate } from 'react-router-dom'
import PriorityFamilyCard from '@/src/components/priority/priority-family-card/PriorityFamilyCard'
import { useStartDiagnosis } from '@/src/hooks/use-start-diagnosis-and-navigate/useStartDiagnosis'
import { useUserPreferences } from '@/src/hooks/use-user-preference-port/useUserPreferencePort'
import { userPreferencesPort } from '@/infra/config/beans'
import PriorityFamilySummary from '@/src/components/priority/priority-family-summary/PriorityFamilySummary'
import React from 'react'
import { toSortedPriorityDiagnoses } from '@/src/utils/priorityDiagnosisUtils'
import {
  FamilyDto,
  PriorityDiagnosesResponseDto,
  PriorityDiagnosisSummaryDto,
} from '@/infra/api/generated/model'
import { trackEvent } from '@/src/analytics/amplitude'

const Index = () => {
  const navigate = useNavigate()
  const { store, team } = useUserPreferences(userPreferencesPort)
  const { startDiagnosis } = useStartDiagnosis()
  const { data: priorityDiagnosesResponse } = useOutletContext<{
    data: PriorityDiagnosesResponseDto
  }>()

  const onEvaluateClick = (family: FamilyDto) => {
    if (family?.id && store?.id && team?.id) {
      startDiagnosis(family, store.id, team.id, 'priorities')
    }
  }

  const onActionClick = (family: FamilyDto, diagnosis: PriorityDiagnosisSummaryDto) => {
    trackEvent('CONTINUE_ACTION_PLAN_BUTTON_CLICK', {
      diagnosisId: diagnosis.id,
      source: 'priorities',
    })
    void navigate(`/diagnoses/${diagnosis.id}/actions`, { state: { source: 'priority' } })
  }

  const { averageScore, completedDiagnoses, totalFamily, priorityDiagnoses } =
    priorityDiagnosesResponse

  return (
    <div className="flex flex-col gap-3">
      <PriorityFamilySummary
        averageScore={averageScore}
        completedDiagnoses={completedDiagnoses}
        totalFamilies={totalFamily}
      />
      {toSortedPriorityDiagnoses(priorityDiagnoses).map((prioDiag) => (
        <PriorityFamilyCard
          key={prioDiag.family.id}
          family={prioDiag.family}
          diagnosis={prioDiag.diagnosis}
          onEvaluateClick={onEvaluateClick}
          onActionClick={onActionClick}
          isExpired={prioDiag.isExpired}
        />
      ))}
    </div>
  )
}

export default Index
